import Main from '@/views/main/main.vue';
import log from './log';

export default {
    path: '/sys_monitor',
    name: 'sys_monitor',
    meta: {icon: 'md-stats'},
    component: Main,
    children: [...log],
};
